import CompanyPage from './pages/company-page';
import FileUploadPage from './pages/file-upload-page';
import SummaryPage from './pages/summary-page';
import SuccessPage from './pages/success-page';
import VueRouter from 'vue-router';
import store from '../../common/js/vuex/store';
const routes = [
	{ name: 'vallalkozas', path: '/vallalkozas', component: CompanyPage },
	{ name: 'fajlfeltoltes', path: '/fajlfeltoltes', component: FileUploadPage },
	{ name: 'osszegzo', path: '/osszegzo', component: SummaryPage },
	{ name: 'sikeres', path: '/sikeres', component: SuccessPage },
	{ path: '*', redirect: '/vallalkozas' }
];

const router = new VueRouter({
	routes,
	scrollBehavior(to) {
		if (to.hash) {
			return {
				selector: to.hash
			};
		}
	}
});
router.afterEach((to) => {
	store.dispatch('eSignature/setCurrentPage', to.name);
	store.dispatch('eSignature/addToVisitedPage', to.name);
});
export default router;
